import { render, staticRenderFns } from "./summer-of-day-warning.vue?vue&type=template&id=4645c1c4&scoped=true"
import script from "./summer-of-day-warning.vue?vue&type=script&lang=js"
export * from "./summer-of-day-warning.vue?vue&type=script&lang=js"
import style0 from "./summer-of-day-warning.vue?vue&type=style&index=0&id=4645c1c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4645c1c4",
  null
  
)

export default component.exports